import {
    ActionTypeNames, ClearImportStatusAction, ImportErrorAction,
    ImportSuccessAction, ImportXMLAction, UpdateImportProgressAction
} from './actions';

export function importXML(
    settings: { hostname: string, secure: boolean, workspaceId: string },
    formData: FormData
): ImportXMLAction {
    return {
        formData,
        hostname: settings.hostname,
        secure: settings.secure,
        type: ActionTypeNames.ImportXML,
        workspaceId: settings.workspaceId,
    };
}

export function updateImportProgress(text: string, progress: number): UpdateImportProgressAction {
    return {
        progress,
        text,
        type: ActionTypeNames.UpdateImportProgress,
    };
}

export function importSuccess(key?: string): ImportSuccessAction {
    return {
        key,
        type: ActionTypeNames.ImportSuccess,
    };
}

export function importError(err: Error): ImportErrorAction {
    return {
        error: err,
        type: ActionTypeNames.ImportError,
    };
}

export function clearImportStatus(): ClearImportStatusAction {
    return {
        type: ActionTypeNames.ClearImportStatus,
    };
}
